import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=9de131fe&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9de131fe')) {
      api.createRecord('9de131fe', component.options)
    } else {
      api.reload('9de131fe', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=9de131fe&", function () {
      api.rerender('9de131fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lHIQXTZZhZfp/JS/pricehelp.vue"
export default component.exports